<template>
  <div class="box" style="width: 50%; margin: auto; background-color: #E5E8E8; text-align: center; ">
    <p class="subtitle is-5" style="color: gray; text-align: center ">
        Page Not Found
    </p>
  </div>
</template>

<script>
    export default {
      name: 'PageNotFound',
      props: {
      },
      methods: {
      }
    }
</script>

<style scoped>
</style>
